module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "masthead"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "header_home"
    }
  }, [_c('div', {
    staticClass: "row row-flat"
  }, [_c('div', {
    staticClass: "col-xs-offset-1"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "logo-csl",
    attrs: {
      "src": require("../assets/images/courtyardstone_landscape_logo.png"),
      "alt": "Couryard Stone & Landscape Logo"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35146ad5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Masthead.vue
// module id = 856
// module chunks = 2